import {Component} from '@angular/core';
import {FaqRootModalComponent} from '../faqRootModal/faqRootModal.component';

@Component({
    selector: 'faq-modal',
    templateUrl: './faqModal.component.html',
    styleUrls: ['./faqModal.component.scss']
})
export class FaqModalComponent {

    rootComponent: any = FaqRootModalComponent;

    constructor() {
    }
}
